// latest: zhangmyh 2017-8-4 9:23 AM
import 'components/filesupload'
/* global $ u ko */

let _model
let enterpriseId = window.global.user.enterpriseId
let id = 987
let url
function init (refer) {
  let vm = {
    model: _model,
    enterpriseId: ko.observable(enterpriseId),
    id: ko.observable(id),
    groupname: function () {
      return 'aptitude_' + _model.getSimpleData()[0].id + '_' + id
    },
    selectData1: [
      { value: '1', name: '基本资质' },
      { value: '2', name: '非基本资质' },
      { value: '3', name: '基本资质3证' },
      { value: '5', name: '基本资质5证' }
    ],
    selectData2: [
      { value: '0', name: '非必须' },
      { value: '1', name: '供应商必须' },
      { value: '2', name: '客户必须' }
    ],
    callback: function (data) {
      // if (data && data.status == 1) {
      //   console.log('callback:data:aplit', data)
      //   let localurl = data.data[0].url.split('/')[0]
      //   url = url.split(localurl)[1]
      // }
      if (data && data.status == 1) { // 上传成功
        $('.u-msg-footer').children('.u-msg-cancel').show()
        $('.u-msg-footer').children('.u-msg-ok').show()
        url = data.data[0].url
        // let localurl = data.data[0].url.split('/')[0]
        // url = url.split(localurl)[1]
      } else if (data && data.status == 2) { // 上传中
        $('.u-msg-footer').children('.u-msg-cancel').hide()
        $('.u-msg-footer').children('.u-msg-ok').hide()
      } else { // 上传失败
        $('.u-msg-footer').children('.u-msg-cancel').show()
        $('.u-msg-footer').children('.u-msg-ok').show()
      }
      vm.model.setValue('filePath', url)
    }
  }
  let app = u.createApp()
  app.init(vm, $('#new_apti_refer')[0])
}

let template = require('./index.html')
export default function (model) {
  _model = model
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/aptitude/index.js